module.exports = __webpack_public_path__ + "./images/3e31a1c2232d5c9c1b42a9c28af31fbb.webp";